module.exports = __webpack_public_path__ + "img/rainbow_half.6e793d33.svg";